<!--Author: Michał Pawłowski-->
<template>
  <header v-if="title != undefined && title != null && title.length > 0">
    {{ title }}
  </header>

  <div class="container" style="padding: 0">
    <div class="row d-flex justify-content-center">
      <div class="col">
        <div class="card list-card">
          <div class="input-box">
            <input
              v-on:keydown.enter="addElement()"
              v-model="elemnetToAdd"
              type="text"
              :class="elementInputClass"
              :placeholder="elementInputPlaceholder"
              aria-describedby="mutable-lisview-element-input-feedback"
              style="height: 33px"
            />
            <div
              class="invalid-feedback"
              id="mutable-lisview-element-input-feedback"
            >
              Ten element jest już na liście
            </div>

            <div @click="addElement()" style="color: green">
              <i>
                <i class="fas fa-plus-circle" />
              </i>
            </div>
          </div>

          <div class="row">
            <nav>
              <ol class="list-group internal-placement" :style="ulStyle">
                <li
                  v-for="li in list"
                  :key="li"
                  class="list-group-item d-flex justify-content-between align-items-start"
                >
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{ li }}</div>
                  </div>
                  <span
                    @click="removeElement(li)"
                    class="badge bg-danger rounded-pill"
                    ><i class="fas fa-trash-alt"
                  /></span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MutableScrollableListView",
  props: {
    title: String,

    listContent: Array,
    ulStyle: { type: String, default: "" },
    elementInputPlaceholder: String,
  },
  emits: ["onAddElement", "onRemoveElement"],
  data() {
    return {
      list: [],
      elemnetToAdd: "",
      elementInputClass: "form-control",
    };
  },
  methods: {
    addElement() {
      var isValid = this.checkForm();
      if (isValid && this.elemnetToAdd.length > 0) {
        this.list.push(this.elemnetToAdd);
        this.$emit("onAddElement", this.elemnetToAdd);
        this.elemnetToAdd = "";
      }
    },
    removeElement(element) {
      this.list = this.list.filter((elem) => {
        return elem != element;
      });
      if (this.list == undefined || this.list == null) {
        this.list = [];
      }
      this.$emit("onRemoveElement", element);
    },
    checkForm() {
      var isValid = true;
      var notValidFieldsCount = 0;

      if (this.elemnetToAdd == null || this.elemnetToAdd == undefined) {
        this.elemnetToAdd = "";
      }

      var elementAlreadyOnList = this.list.find(
        (elem) => elem === this.elemnetToAdd
      );

      if (elementAlreadyOnList != null && elementAlreadyOnList != undefined) {
        this.elementInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.elementInputClass = "form-control";
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }

      return isValid;
    },
  },
  watch: {
    elemnetToAdd: {
      handler(newVal) {
        if (newVal in this.list) {
          this.elementInputClass = "form-control is-invalid";
        }
      },
      deep: true,
    },
  },
  created() {
    this.list = [];
    if(this.listContent != undefined && this.listContent != null && this.listContent.length > 0){
      this.list = JSON.parse(JSON.stringify(this.listContent));
    }
  },
};
</script>
<style scoped>
nav ul {
  height: 200px;
  width: 100%;
}

nav ul {
  overflow: hidden;
  overflow-y: scroll;
}

.internal-placement {
  padding: 15px;
}

.list-card {
  background-color: #f5f5dc52;
  padding: 0;
}
</style>
